/**
 * Browser translators (Chrome Translate) swap the app's text nodes for their own <font> wrappers. React still
 * holds the old nodes, so its next removeChild / insertBefore throws NotFoundError and the whole app falls to the
 * error screen. These two checks only act on that failing case; every other call is untouched.
 */
export function installTranslatorDomGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child;
    return removeChild.call(this, child) as T;
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    // The reference was moved: add at the end so the new content still shows.
    return insertBefore.call(this, node, ref && ref.parentNode !== this ? null : ref) as T;
  };
}
